import { Injectable } from '@angular/core';
import * as title from "../../../../data/title.json";

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  titleList: any = (title as any).default;

  constructor() { }

  getTitle(titleId){
    let filteredTitle = this.titleList.find(x=>x.value==titleId)
    return filteredTitle?.title ; 
  }
}
